import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { TranscodingService, MediaclipJobDefinition, JobDetails, MediaclipJob } from '../../../services/transcoding.service';
import { TranslateService } from '../../../../node_modules/@ngx-translate/core';
import { WebSocketsService } from '../../../services/web-sockets.service';
import { Subscription, combineLatest } from 'rxjs';

@Component({
	selector: 'bb-transcoding',
	templateUrl: './bb-transcoding.component.html',
	styleUrls: ['./bb-transcoding.component.scss']
})

export class BbTranscodingComponent implements OnInit, OnDestroy {

	@Input() mediaclipId: string;
	@Output() finished: EventEmitter<boolean>;

	jobs: JobDetails[];

	subscriptions: Subscription;
	websocketSubscription: Subscription;

	constructor(
		private translation: TranslateService,
		private transcodingService: TranscodingService,
		private webSocketsService: WebSocketsService
	) {
		this.finished = new EventEmitter<boolean>();
		this.subscriptions = new Subscription();
		this.webSocketsService.useDevelopment = true;
	}

	ngOnInit() {
		if (this.mediaclipId) {
			this.subscriptions.add(combineLatest([this.transcodingService.mediaclipJobDefinitionsSubject, this.transcodingService.jobsSubject])
				.subscribe((res: any[]) => {
					if (res) {
						const mediaclipJobDefinitions: MediaclipJobDefinition[] = res[0];
						const mediaclipJobArray: MediaclipJob[] = res[1];

						if (mediaclipJobDefinitions && mediaclipJobArray && mediaclipJobArray.length > 0) {
							const mediaclipJob = mediaclipJobArray.find(clipJob => clipJob && clipJob.id === this.mediaclipId);

							if (mediaclipJob && mediaclipJob.mediajobs && mediaclipJob.mediajobs.length > 0) {
								const jobs = mediaclipJob.mediajobs;
								this.jobs = jobs;

								if (this.jobs) {
									this.jobs.map((job: JobDetails) => {
										const jobDefinitions = mediaclipJobDefinitions
											.filter((mediaclipJobDefinition: MediaclipJobDefinition) => mediaclipJobDefinition.id === job.mediajobdefid);

										if (jobDefinitions && jobDefinitions.length > 0) {
											job.mediaJobName = jobDefinitions[0].name;
										}
									});
								}
							}
						}
					}
				})
			);
		}
	}

	ngOnDestroy() {
		if (this.subscriptions) {
			this.subscriptions.unsubscribe();
		}
		if (this.websocketSubscription) {
			this.websocketSubscription.unsubscribe();
		}
	}

	getStylePercentage(job: any): any {
		return { width: (this.transcodingService.getPercentage(job) * 100) + '%' };
	}

	getProgressLabel(job: JobDetails) {
		if (job && job.status === 'error') {
			return this.translation.instant('ERROR');
		}
	}

	getErrors() {
		let errors = 0;

		this.jobs.forEach((job) => {
			if (job && job.status === 'error') {
				errors++;
			}
		});
		return errors;
	}
}
